import { BlockGroupProps } from "@/types/Block";

import { Block } from "./Block";

export const BlockGroup: React.FC<BlockGroupProps> = ({ blocks }) => {
  return blocks.map((block, i) => <Block key={i} {...block} />);
};
